import { VIEWED_MM_MODAL_ON_KB } from "../../constants";

const getRoot = state => state.user

export const getUserID = state => getRoot(state).id

export const getMMModalViewedProperty = state => getRoot(state).settings[VIEWED_MM_MODAL_ON_KB]